module.exports = "/assets/packs/images/472addd2e9b429663cbb2765cf46bd2f.svg";